export default {
  carregando: false,
  items: [],
  paginacao: null
}
